import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=594a1503&scoped=true&"
import script from "./Banners.vue?vue&type=script&lang=js&"
export * from "./Banners.vue?vue&type=script&lang=js&"
import style0 from "./Banners.vue?vue&type=style&index=0&id=594a1503&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594a1503",
  null
  
)

export default component.exports